import { httpCreators, HttpResponse } from 'rbh-merchant-core';
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { generalCreators } from '../../../../../redux/general/general-action';
import { MODAL_TYPE } from '../../../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../../../redux/general/general-reducer';
import { Branch } from '../../../../../shared/models/branch';
import { PosProvider } from '../../../../../shared/models/pos-provider';
import { Images } from '../../../../../shared/theme';
import { FoodMenuService } from '../../../FoodMenu/redux/foodmenu-service';
import { posCreators } from './pos-action';
import { POS_REQUEST_ID_LIST, POS_STATUS, POS_STATUS_CODE, POS_TRANSLATION_KEY } from './pos-constant';
import { POS_STATE_KEY } from './pos-reducer';
import { POS_ACTION_TYPE } from './pos-type';

function* getPosCurrentStepHandler(resp: HttpResponse, callbackParams: {
  shopData: Branch; toPosStep: (posStep: number) => void;
  toAddFoodMenu: () => void; checkIsActivatePos: (shopData: Branch) => void;
}) {
  if (resp.success) {
    yield put(posCreators.setPosState(POS_STATE_KEY.POS_SHOP_DATA, callbackParams.shopData));
    yield put(posCreators.setPosState(POS_STATE_KEY.PREFILLED_FORM_STEP_3, undefined));
    if (resp.data.isActivate) {
      yield call(callbackParams.checkIsActivatePos, callbackParams.shopData);
    } else if (callbackParams.shopData.posStatus === POS_STATUS.PS03 &&
      callbackParams.shopData.posStep === 0 && !callbackParams.shopData.isActivate) {
      yield call(callbackParams.toPosStep, 3);
    } else {
      yield call(callbackParams.toPosStep, resp.data.posStep);
    }
  } else if (resp.statusCode === 1899 && resp.data?.translationKey === POS_TRANSLATION_KEY.NO_MENU) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { callbackParams.toAddFoodMenu(); },
      type: MODAL_TYPE.POS_NO_FOOD_FOUND
    }));
  } else if (resp.statusCode === 1899 && resp.data?.translationKey === POS_TRANSLATION_KEY.SHOP_IN_PROCESS) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalContentId: 'pos-branch-in-progress',
      modalContent: 'main.posManagement.posActivate.popup.branchInProgress.content',
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* callPosFoodMenu(callbackParams: any) {
  yield put(httpCreators.request({
    id: POS_REQUEST_ID_LIST.GET_POS_FOOD_MENU,
    sagaHandler: getPosFoodMenuHandler as any,
    service: FoodMenuService.getFoodMenus,
    callbackParams
  }));
}

function* getPosFoodMenuHandler(resp: HttpResponse, callbackParams: { checkIsEmpty: (menu: []) => void, resetReload: () => void }) {
  if (resp.success) {
    yield put(posCreators.setPosState(POS_STATE_KEY.POS_FOOD_MENU, resp?.data?.menus));
    yield call(callbackParams.checkIsEmpty, resp?.data?.menus);
  } else {
    yield put(posCreators.setPosState(POS_STATE_KEY.POS_FOOD_MENU, undefined));
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { callbackParams.resetReload(); },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* patchPosMenusHandler(resp: HttpResponse, callbackParams: {
  afterStep1Save: () => void, partialUpdate: () => void, toPath: (path: string) => void
}) {
  if (resp.success) {
    yield put(posCreators.setPosState(POS_STATE_KEY.POS_FOOD_MENU, []));
    yield call(callbackParams.afterStep1Save);
  } else if (resp.statusCode === 1899 && resp.data?.translationKey === POS_TRANSLATION_KEY.PARTIAL_UPDATE) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { callbackParams.partialUpdate(); },
      type: MODAL_TYPE.ERROR
    }));
  } else if (resp.statusCode === 1899 && resp.data?.translationKey === POS_TRANSLATION_KEY.NO_MENU) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onCancel: () => { callbackParams.toPath('/main/posmanagement'); },
      onOk: () => { callbackParams.toPath('/main/addmenu'); },
      type: MODAL_TYPE.POS_NO_FOOD_FOUND
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* getPosMenuModifierItemHandler(resp: HttpResponse, callbackParams: { resetReload: () => void }) {
  if (resp.success) {
    yield put(posCreators.setPosState(POS_STATE_KEY.POS_MENU_MODIFIER_ITEM, resp?.data?.menuModifierItems));
  } else {
    yield put(posCreators.setPosState(POS_STATE_KEY.POS_MENU_MODIFIER_ITEM, []));
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { callbackParams.resetReload(); },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* patchPosMenuModifierItemHandler(resp: HttpResponse, callbackParams: { afterStep2Save: () => void }) {
  if (resp.success) {
    yield put(posCreators.setPosState(POS_STATE_KEY.POS_MENU_MODIFIER_ITEM, []));
    yield call(callbackParams.afterStep2Save);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* getPosProviderHandler(resp: HttpResponse, callbackParams: {
  setAndPrefillValues: (list: PosProvider[], values?: any) => void, values?: any,
  getPosProvider: (values?: any) => void
}) {
  if (resp.success && resp?.data?.posProvider?.length > 0) {
    yield call(callbackParams?.setAndPrefillValues, resp?.data?.posProvider, callbackParams?.values);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        callbackParams?.getPosProvider(callbackParams?.values); // NOSONAR [typescript:S905] will support optional chaining in SonarQube 8.5
      },
      type: MODAL_TYPE.ERROR,
      clickClosable: false
    }));
  }
}

function* updatePosStep3Handler(resp: HttpResponse, callbackParams: {
  history: any, pathName: string, getPosProvider: (selected?: number) => void, values?: any
}) {
  if (resp.success) {
    yield put(posCreators.setPosState(POS_STATE_KEY.PREFILLED_FORM_STEP_3, callbackParams?.values));
    if (callbackParams?.pathName === '/main/posmanagement/step3') {
      yield put(posCreators.setPosState(POS_STATE_KEY.ALERT_SUCCESS, true));
      yield call(callbackParams?.getPosProvider, callbackParams?.values);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      yield call(callbackParams?.history?.push, callbackParams?.pathName);
    }
  } else {
    yield delay(200);
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* postMhStatusHandler(resp: HttpResponse, callbackParams: { history: any }) {
  if (resp.success && resp?.data?.posStatusCode === POS_STATUS_CODE.POS_VERIFIED) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    yield call(callbackParams?.history?.push, '/main/posmanagement/step4');
  } else if (resp.success && resp?.data?.posStatusCode === POS_STATUS_CODE.POS_UNVERIFIED) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalImage: Images.redAlert,
      modalTitle: 'main.posManagement.posActivate.popup.posUnverified.header',
      modalContent: 'main.posManagement.posActivate.popup.posUnverified.content',
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  } else if (resp.statusCode === 1899 && resp.data?.translationKey === POS_TRANSLATION_KEY.NO_MENU) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onCancel: () => {
        callbackParams?.history.push('/main/posmanagement'); // NOSONAR [typescript:S905] will support optional chaining in SonarQube 8.5
      },
      onOk: () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        callbackParams?.history.push('/main/addmenu'); // NOSONAR [typescript:S905] will support optional chaining in SonarQube 8.5
      },
      type: MODAL_TYPE.POS_NO_FOOD_FOUND
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* updatePosStep4Handler(resp: HttpResponse, callbackParams: { history: any, pathName: string, resetForm: () => void }) {
  if (resp.success) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    yield call(callbackParams?.history?.push, callbackParams?.pathName);
  } else if (resp.data?.translationKey === POS_TRANSLATION_KEY.START_DATE_ERROR) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        callbackParams?.resetForm(); // NOSONAR [typescript:S905] will support optional chaining in SonarQube 8.5
      },
      type: MODAL_TYPE.ERROR
    }));
  } else if (resp.data?.translationKey === POS_TRANSLATION_KEY.POS_ALREADY_ACTIVATED) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        callbackParams?.history?.push('/main/posmanagement'); // NOSONAR [typescript:S905] will support optional chaining in SonarQube 8.5
      },
      type: MODAL_TYPE.ERROR
    }));
  } else {
    yield delay(200);
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => { },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* patchCancelPosHandler(resp: HttpResponse, callbackParams: {
  alertCancelPosSuccess: () => void, alertCancelPosFail: () => void, toPath: (path: string) => void,
  alertDeactivatePosSuccess: () => void, alertDeactivatePosFail: () => void, resetCallBranch: () => void }) {
  if (resp.success) {
    if (callbackParams.resetCallBranch && callbackParams.alertDeactivatePosSuccess) {
      yield call(callbackParams?.resetCallBranch);
      yield call(callbackParams?.alertDeactivatePosSuccess);
    } else {
      yield call(callbackParams?.toPath, '/main/posmanagement');
      yield call(callbackParams?.alertCancelPosSuccess);
    }
  } else {
    if (callbackParams.resetCallBranch && callbackParams.alertDeactivatePosFail) {
      yield call(callbackParams?.resetCallBranch);
      yield call(callbackParams?.alertDeactivatePosFail);
    } else {
      yield call(callbackParams?.toPath, '/main/posmanagement');
      yield call(callbackParams?.alertCancelPosFail);
    }
  }
}

export const posSagas = {
  callPosFoodMenu,
  getPosFoodMenuHandler,
  getPosCurrentStepHandler,
  patchPosMenusHandler,
  getPosProviderHandler,
  postMhStatusHandler,
  updatePosStep3Handler,
  updatePosStep4Handler,
  getPosMenuModifierItemHandler,
  patchPosMenuModifierItemHandler,
  patchCancelPosHandler,
  watchers: [
    takeLatest(POS_ACTION_TYPE.CALL_POS_FOOD_MENU, callPosFoodMenu)
  ]
};
